const DEFAULT_SORT = 'title-az';

const sorters = {
  'title-az': (a, b) => a.title.localeCompare(b.title),
  'title-za': (a, b) => b.title.localeCompare(a.title),
  'year-new': (a, b) => (b.year - a.year) || a.title.localeCompare(b.title),
  'year-old': (a, b) => (a.year - b.year) || a.title.localeCompare(b.title),
  'popular': (a, b) =>
    (Number(b.popular) - Number(a.popular)) || a.title.localeCompare(b.title),
};

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Render basic inline markdown (*italic*, **bold**) in work summaries. */
function formatInlineMarkdown(text) {
  const escaped = escapeHtml(text);
  return escaped
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>')
    .replace(/_([^_]+)_/g, '<em>$1</em>');
}

function readState(controls) {
  return {
    category: controls.category?.value || '',
    tag: controls.tag?.value || '',
    sort: controls.sort?.value || DEFAULT_SORT,
  };
}

function applyFilters(items, state) {
  const sortFn = sorters[state.sort] || sorters[DEFAULT_SORT];
  return items
    .filter((it) => !state.category || (it.categories || []).includes(state.category))
    .filter((it) => !state.tag || (it.tags || []).includes(state.tag))
    .slice()
    .sort(sortFn);
}

function render(listEl, tpl, items, emptyEl, countEl) {
  listEl.replaceChildren();
  items.forEach((item) => {
    const node = tpl.content.cloneNode(true);
    const link = node.querySelector('[data-field="link"]');
    if (link) link.setAttribute('href', item.url);
    const title = node.querySelector('[data-field="title"]');
    if (title) title.textContent = item.title;
    const year = node.querySelector('[data-field="year"]');
    if (year) year.textContent = item.year ? `(${item.year})` : '';
    const summary = node.querySelector('[data-field="summary"]');
    if (summary) summary.innerHTML = formatInlineMarkdown(item.summary || '');
    listEl.appendChild(node);
  });
  if (emptyEl) emptyEl.hidden = items.length > 0;
  if (countEl) {
    countEl.textContent = `${items.length} work${items.length === 1 ? '' : 's'}`;
  }
}

function syncURL(state) {
  const p = new URLSearchParams();
  if (state.category) p.set('category', state.category);
  if (state.tag) p.set('tag', state.tag);
  if (state.sort && state.sort !== DEFAULT_SORT) p.set('sort', state.sort);
  const qs = p.toString();
  const url = qs ? `${location.pathname}?${qs}` : location.pathname;
  history.replaceState(null, '', url);
}

function hydrateFromURL(controls) {
  const params = new URLSearchParams(location.search);
  const setIfPresent = (el, key) => {
    if (!el) return;
    const val = params.get(key);
    if (val !== null && Array.from(el.options).some((o) => o.value === val)) {
      el.value = val;
    }
  };
  setIfPresent(controls.category, 'category');
  setIfPresent(controls.tag, 'tag');
  setIfPresent(controls.sort, 'sort');
}

export function initWorksFilter() {
  const root = document.querySelector('[data-works-filter]');
  if (!root) return;

  const dataEl = root.querySelector('[data-works-data]');
  const listEl = root.querySelector('[data-works-list]');
  const tpl = root.querySelector('template[data-work-card]');
  const emptyEl = root.querySelector('[data-empty]');
  const countEl = root.querySelector('[data-count]');
  if (!dataEl || !listEl || !tpl) return;

  let items = [];
  try {
    items = JSON.parse(dataEl.textContent || '[]');
  } catch (err) {
    console.error('works-filter: failed to parse data', err);
    return;
  }

  const controls = {
    category: root.querySelector('[data-control="category"]'),
    tag: root.querySelector('[data-control="tag"]'),
    sort: root.querySelector('[data-control="sort"]'),
  };

  hydrateFromURL(controls);

  const update = () => {
    const state = readState(controls);
    render(listEl, tpl, applyFilters(items, state), emptyEl, countEl);
    syncURL(state);
  };

  Object.values(controls).forEach((el) => {
    if (el) el.addEventListener('change', update);
  });

  const clearBtn = root.querySelector('[data-action="clear"]');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      if (controls.category) controls.category.value = '';
      if (controls.tag) controls.tag.value = '';
      if (controls.sort) controls.sort.value = DEFAULT_SORT;
      update();
    });
  }

  update();
}
